import {
  Avatar,
  Badge,
  Box,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import {
  NotificationsNoneOutlined,
  SmsOutlined,
  SettingsOutlined,
  SearchOutlined,
} from "@mui/icons-material";
import notf from "../assets/images/svg/notf.svg";
import chatHeader from "../assets/images/svg/chatHeader.svg";
import setting from "../assets/images/svg/setting.svg";
import avatarIcon from "../assets/images/svg/avatar.svg";
import { BASE_URL } from "../constants";
import { useNavigate } from "react-router-dom";
import GlobalSearch from "./GlobalSearch";
import Notifications from "./notification/Notifications";
import { useAdmin } from "./AdminProvider";

export function Header() {
  const {
    adminData: { data: user = {} },
  } = useAdmin();
  const capitalizeFirstLetter = (string) => {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  const navigate = useNavigate();
  return (
    <Grid container sx={{ padding: "30px 18px", paddingBottom: "20px" }}>
      <Grid
        item
        xs={12}
        md={7}
        lg={9}
        sx={{ borderRight: "1px solid #D0D6DE" }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
            cursor: "pointer",
          }}
        >
          <GlobalSearch />
          <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <Notifications />
            {/* <IconButton
              sx={{
                background: "#673C8E59",
                // color: "#673C8E",
                mr: "30px",
                borderRadius: "15px",
              }}
            >
              <img
                // onClick={() => navigate("/services/chats")}
                style={{ width: "26px" }}
                src={chatHeader}
                alt="Logo"
              />
            </IconButton> */}
            <IconButton
              sx={{
                background: "#074F2459",
                // color: "#074F24",
                mr: "18px",
                borderRadius: "15px",
              }}
            >
              <img
                onClick={() => navigate("/others/account-settings")}
                style={{ width: "26px" }}
                src={setting}
                alt="Logo"
              />
            </IconButton>
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12} md={5} lg={3} sx={{ textAlign: "right", pr: 3 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            gap: 2,
            cursor: "pointer",
          }}
        >
          <Typography sx={{ textTransform: "capitalize" }}>
            Hello, <b>{user?.name}</b>
          </Typography>
          <Avatar
            onClick={() => navigate("/others/account-settings")}
            sx={{ background: "#673C8E" }}
            alt={capitalizeFirstLetter(user?.name)}
            src={user?.profile || avatarIcon}
          />
        </Box>
      </Grid>
    </Grid>
  );
}
